import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectBuildingHandOverFromYear = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('yeargte')(jsonQuery),
);
